import React from 'react';

const NonRegisteredBadge = () => {
  return (
    <div className="non-registered-badge mt-1">
      <p>Non Registered User</p>
    </div>
  );
};

export default NonRegisteredBadge;
